import React, {useContext, useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import 'styles/pictures/detail/PictureDetail.css';
import {useSwipeable} from 'react-swipeable';
import PictureItem from 'components/pictures/display/PictureItem';
import {PicturesContext} from 'util/image/PictureContext';
import {UserContext} from 'components/user/UserContext';
import {usePopup} from 'popup/PopupContext';
import PictureCommentsPane from 'components/pictures/detail/PictureCommentsPane';
import QuestionMark from 'components/menu/QuestionMark';
import UnderImageDetailPane from "./UnderImageDetailPane";

const PictureDetail = () => {
    const {id, browsing} = useParams();
    const navigate = useNavigate();
    const {user} = useContext(UserContext);
    const {sortedByAmount, sortedByLastAuthorPayment, sortedByTrending} = useContext(PicturesContext);
    const [pictureList, setPictureList] = useState([]);
    const [picture, setPicture] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(null);
    const [canShowNext, setCanShowNext] = useState(false);
    const [canShowPrevious, setCanShowPrevious] = useState(false);
    const [isMyImage, setIsMyImage] = useState(false);
    const [isImageMy, setIsImageMy] = useState(false);
    const {isPopupOpen} = usePopup();
    const [imageTop, setImageTop] = useState(null);
    const [imageTrending, setImageTrending] = useState(null);

    useEffect(() => {
        let myList = [];
        switch (browsing) {
            case 'top':
                myList = sortedByAmount;
                break;
            case 'trending':
                myList = sortedByTrending;
                break;
            case 'profile':
                const allAuthors = sortedByLastAuthorPayment;
                const authorPicture = allAuthors.find((pic) => pic.id === id);
                myList = allAuthors.filter((pic) => pic.authorId === authorPicture.authorId);
                break;
            default:
                break;
        }

        if (!myList || myList.length === 0) {
            return;
        }

        const foundPicture = myList.find((pic) => pic.id === id);
        setPicture(foundPicture);
        setIsMyImage(foundPicture.authorId === user.userId);

        const index = myList.findIndex((pic) => pic.id === id);
        setCurrentIndex(index);
        setPictureList(myList);

        setCanShowNext(index < myList.length - 1);
        setCanShowPrevious(index > 0);

        // ranking calculation (same logic as ShareImage)
        const topIndex = sortedByAmount.findIndex((pic) => pic.id === id);
        const trendingIndex = sortedByTrending.findIndex((pic) => pic.id === id);

        setImageTop(topIndex >= 0 ? topIndex + 1 : null);
        setImageTrending(trendingIndex >= 0 ? trendingIndex + 1 : null);

    }, [id, sortedByAmount, sortedByLastAuthorPayment, sortedByTrending, browsing, user.userId]);

    useEffect(() => {
        if (!user || !picture) {
            setIsImageMy(false);
            return;
        }
        setIsImageMy(picture.authorId === user.userId);
    }, [picture, user]);

    const navigationClick = (side) => {
        if (side === 'R') {
            handleNext();
        } else {
            handlePrevious();
        }
    };

    const handleNext = () => {
        if (currentIndex < pictureList.length - 1) {
            const nextPicture = pictureList[currentIndex + 1];
            navigate(`/image/${browsing}/${nextPicture.id}`, {replace: true});
        }
    };

    const handlePrevious = () => {
        if (currentIndex > 0) {
            const previousPicture = pictureList[currentIndex - 1];
            navigate(`/image/${browsing}/${previousPicture.id}`, {replace: true});
        }
    };

    const handlers = useSwipeable({
        onSwipedLeft: () => {
            if (!isPopupOpen && canShowNext) {
                handleNext();
            }
        },
        onSwipedRight: () => {
            if (!isPopupOpen && canShowPrevious) {
                handlePrevious();
            }
        },
        preventDefaultTouchmoveEvent: true,
        trackMouse: true,
    });

    if (!picture) {
        return <p>Loading...</p>;
    }

    return (
        <div className="main-content-body-padding">
            <div className="picture-author-content-divider">
                <div {...handlers} className="image-container">
                    <PictureItem
                        pic={picture}
                        listType={browsing}
                        index={currentIndex}
                        navigationClick={navigationClick}
                        canShowNext={canShowNext}
                        canShowPrevious={canShowPrevious}
                        isDetail={true}
                    />
                </div>

                <UnderImageDetailPane
                    imageId={id}
                    isMyImage={isMyImage}
                    imageTop={imageTop}
                    imageTrending={imageTrending}
                />

                <div className="image-container-question-mark">
                    <QuestionMark/>
                </div>
            </div>

            <PictureCommentsPane
                pictureId={id}
                isImageMy={isImageMy}
            />
        </div>
    );
};

export default PictureDetail;
